import { React, useEffect } from "react";
import AOS from "aos";
import { Container } from "react-bootstrap";
import { ArrowRight } from "react-bootstrap-icons";
import { Link } from "react-router-dom";
import Faq from "./Faq";

const Faqs = () => {
  useEffect(() => {
    AOS.init({ duration: 1500 });
  }, []);
  const faqs = [
    {
      ques: "What is Logistat?",
      ans: "Logistat is a group of software appications used for optimizing logistics services. It is a combination of customer’s app, a rider’s app, an admin web portal and a website customized to fit your company’s brand.",
      id: 1,
    },
    {
      ques: "Who is it for?",
      ans: "Logistat is for door to door delivery companies",
      id: 2,
    },
    {
      ques: "What are the payment plans available?",
      ans: "",
      id: 3,
    },
    {
      ques: "Is there a limit to the number of outlets I can create?",
      ans: "There is no limit to the number of central back offices that the platform allows you to create.",
      id: 4,
    },
    {
      ques: "Is there a user mobile app?",
      ans: "Yes, a user mobile app is part of the software offering.",
      id: 5,
    },
    {
      ques: "Is there a rider mobile app?",
      ans: "Yes.",
      id: 6,
    },
  ];

  const fontSize = {
    fontFamily: "Proxima Nova",
    fontSize: "1.07rem",
  };

  return (
    <Container className="faqsWidth my-5 pb-3">
      <div className="faqs pt-5" id="faq" data-aos="fade-up">
        <div className="faq-header text-center">
          <h3 data-aos="fade-right" className="fw-bold">
            FAQs
          </h3>

          <span style={fontSize}>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lectus
            lorem magna vulputate a. Turpis diam sapien quam aliquet a sit.
          </span>
          {faqs.map((faq) => {
            return (
              <div className="faq-body mt-4 px-2 px-md-0" key={faq.id}>
                <Faq faq={faq} />
              </div>
            );
          })}
          <div>
            <hr />
            <Link
              to="/FaqPage"
              onClick={() => {
                window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
              }}
              className="text-decoration-none"
            >
              <p
                className="py-2 d-inline-block fs-6"
                style={{ color: "#28B672" }}
              >
                View All
                <span>
                  <ArrowRight className="ms-1 pb-1 fs-4" />
                </span>
              </p>
            </Link>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default Faqs;
